export const enToRuMap = {
    q: 'й', w: 'ц', e: 'у', r: 'к', t: 'е', y: 'н', u: 'г', i: 'ш', o: 'щ', p: 'з',
    '[': 'х', ']': 'ъ', a: 'ф', s: 'ы', d: 'в', f: 'а', g: 'п', h: 'р', j: 'о',
    k: 'л', l: 'д', ';': 'ж', "'": 'э', z: 'я', x: 'ч', c: 'с', v: 'м', b: 'и',
    n: 'т', m: 'ь', ',': 'б', '.': 'ю', '/': '.', '`': 'ё', ' ': ' '
};

export const convertToMistyped = (text, map = enToRuMap) => {
    const reverseMap = Object.fromEntries(
        Object.entries(map).map(([key, value]) => [value, key])
    );
    return text.toLowerCase().split('').map(char => reverseMap[char] || char).join('');
};
